module.exports = __webpack_public_path__ + "img/sentaosa-logo.9eb77fc6.png";